export const ORDERS_AUTH_ROUTES = {
  LANDING: "/orders-auth",
  OTP: "/orders-auth/otp",
  SUCCESS: "/orders-auth/success",
  ERROR: '/orders-auth/error'
};
